import { TenantSettings } from '@/types/settings.types';
import { axios } from '@/lib/axios';

const SettingsService = {
  getEnv: async (): Promise<TenantSettings> => {
    const { data } = await axios.get<TenantSettings>('/api/settings/env');
    return data;
  },

  getSubscriptionStatus: async (): Promise<{ active: boolean }> => {
    const { data } = await axios.get<{ active: boolean }>('/api/settings/subscription-status');
    return data;
  },
};

export default SettingsService;
